import { Component, Input } from '@angular/core';
import { ErrorInterface, NotificationInterface } from 'outshared-lib';

@Component({
    selector: 'ins-insurance-notification',
    templateUrl: 'insurance-notification.component.html',
})
export class InsuranceNotificationComponent {
    @Input() invert: boolean = false;
    @Input() errorNotifications: ErrorInterface[] = [];

    /** @deprecated use errorNotifications instead */
    @Input() notifications: NotificationInterface[] = [];
}
